import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import MediaQuery from 'react-responsive';

export default class ResponsiveStepper extends React.Component {
  render() {
    const { steps, activeStep } = this.props;

    return (
      <React.Fragment>
        <MediaQuery maxWidth={767}>
          <Stepper activeStep={activeStep} orientation="vertical" style={{margin: '1.5em 0'}}>
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </MediaQuery>
        <MediaQuery minWidth={767}>
          <Stepper activeStep={activeStep} style={{margin: '1.5em 0'}}>
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </MediaQuery>
      </React.Fragment>
    );
  }
}
